import { render, staticRenderFns } from "./SelectProductCategory.vue?vue&type=template&id=0348413e&scoped=true&"
import script from "./SelectProductCategory.vue?vue&type=script&lang=js&"
export * from "./SelectProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./SelectProductCategory.vue?vue&type=style&index=0&id=0348413e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0348413e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu,VSelect})
